// import { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Box,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
// } from "@mui/material";

// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Button,
// } from "@mui/material";
// import { CircularProgress } from "@mui/material";

// import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import DevicesIcon from "@mui/icons-material/Devices";
// import EditDevice from "./EditDevice";
// import "./ViewDevice.css";
// import apiService from "../../utils/apiservice";



// const API_URL = process.env.REACT_APP_API_DJANGO_URL;

// const ViewDevices = () => {
//   const [devices, setDevices] = useState([]);
//   const [deleteOpen, setDeleteOpen] = useState(false);
//   const [deviceToDelete, setDeviceToDelete] = useState(null);
//   const [editOpen, setEditOpen] = useState(false);
//   const [deviceToEdit, setDeviceToEdit] = useState(null);
//   const [sites, setSites] = useState([]);
//   const [selectedSite, setSelectedSite] = useState("all"); // default to All
//   const token = localStorage.getItem("accessToken");
//  const [customers, setCustomers] = useState([]);
// const [selectedCustomer, setSelectedCustomer] = useState("");
//   const [deleteMessage, setDeleteMessage] = useState("");
//   const [deleteError, setDeleteError] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Add these inside your ViewSites component
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   // Add these handlers below your state definitions
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };



//   useEffect(() => {
//   const fetchCustomers = async () => {
//     try {
//       const response = await apiService.get(
//         `${API_URL}/api/get_customers/`,
//         { data: {} }
//       );

//       const customerData = response.data || [];
//       setCustomers(customerData);

//       if (customerData.length > 0) {
//         setSelectedCustomer(customerData[0].tb_customer_id);
//       }
//     } catch (error) {
//       console.error("Error fetching customers:", error);
//     }
//   };

//   fetchCustomers();
// }, []);

//   useEffect(() => {
//     const fetchSites = async () => {
//       try {
//         // const response = await axios({
//         //   url: `${API_URL}/api/get_customer_sites/${customerId}/`,
//         //   method: "GET",
//         //   headers: {
//         //     Authorization: `Bearer ${token}`,
//         //     Accept: "application/json",
//         //     "Content-Type": "application/json",
//         //   },
//         //   data: {}, // 🔥 IMPORTANT: forces Content-Type header
//         // });

//         const response = await apiService({
//           url: `/api/get_customer_sites/${selectedCustomer}/`,
//           method: "GET",
//           data: {}, // ✅ keep as it is
//         });

//         const siteData = response.data.data;
//         // setSites(siteData);
//         // if (siteData.length > 0) {
//         //   setSelectedSite(siteData[0].asset_id);
//         // }

//         setSites(siteData);
//         // Only set default to first site if selectedSite is empty
//         if (!selectedSite || selectedSite === "all") {
//           setSelectedSite("all"); // Keep default as "all"
//         }
//       } catch (error) {
//         console.error("Error fetching sites:", error);
//       }
//     };

//     if (selectedCustomer) fetchSites();
//   }, [selectedCustomer, token]);



//   useEffect(() => {
//     const fetchDevices = async () => {
//      if (!selectedCustomer) return;
//       setLoading(true); 

//       try {
//         let deviceList = [];

//         if (selectedSite === "all") {
//           // 1️⃣ Fetch all devices for customer
//           const response = await axios.get(
//             `${API_URL}/api/customer_alldevices/${selectedCustomer}/?page=0&pageSize=1000`,
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`,
//                 Accept: "application/json",
//                 "Content-Type": "application/json",
//               },
//               data: {},
//             }
//           );

//           const allDevices = response.data.data.data || [];

//           // Fetch attributes for each device
//           deviceList = await Promise.all(
//             allDevices.map(async (device, index) => {
//               let latitude = "-";
//               let longitude = "-";
//               let is_enabled = false;

//               try {
//                 const attrRes = await axios.get(
//                   `${API_URL}/api/device_attributes/${device.id.id}/`,
//                   {
//                     headers: { Authorization: `Bearer ${token}` },
//                   }
//                 );

//                 const attrsArray = attrRes.data.attributes || [];

//                 const latitudeAttr = attrsArray.find(attr => attr.key === "latitude");
//                 const longitudeAttr = attrsArray.find(attr => attr.key === "longitude");
//                 const activeAttr = attrsArray.find(attr => attr.key === "active");

//                 latitude = latitudeAttr ? latitudeAttr.value : "-";
//                 longitude = longitudeAttr ? longitudeAttr.value : "-";
//                 is_enabled = activeAttr ? activeAttr.value : false;
//               } catch (err) {
//                 console.error(`Error fetching attributes for ${device.id.id}`, err);
//               }

//               return {
//                 id: index + 1,
//                 device_id: device.id.id,
//                 device_name: device.name,
//                 latitude,
//                 longitude,
//                 is_enabled,
//               };
//             })
//           );
//         } else {
//           // 2️⃣ Fetch devices for selected site
//           const response = await axios.get(
//             `${API_URL}/api/site_devices/${selectedSite}/`,
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`,
//                 Accept: "application/json",
//                 "Content-Type": "application/json",
//               },
//               data: {},
//             }
//           );

//           const siteDevices = response.data.devices || [];

//           // Fetch attributes for each device
//           deviceList = await Promise.all(
//   siteDevices.map(async (device, index) => {
//     let latitude = "-";
//     let longitude = "-";
//     let is_enabled = false;

//     try {
//       const attrRes = await axios.get(
//         `${API_URL}/api/device_attributes/${device.device_id}/`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       const attrsArray = attrRes.data.attributes || [];

//       const latitudeAttr = attrsArray.find(attr => attr.key === "latitude");
//       const longitudeAttr = attrsArray.find(attr => attr.key === "longitude");
//       const activeAttr = attrsArray.find(attr => attr.key === "active");

//       latitude = latitudeAttr ? latitudeAttr.value : "-";
//       longitude = longitudeAttr ? longitudeAttr.value : "-";
//       is_enabled = activeAttr ? activeAttr.value : false;
//     } catch (err) {
//       console.error(
//         `Error fetching attributes for device ${device.device_id}`,
//         err
//       );
//     }

//     return {
//       id: index + 1,
//       device_id: device.device_id,
//       device_name: device.device_name,
//       latitude,
//       longitude,
//       is_enabled,
//     };
//   })
// );
//         }

//         setDevices(deviceList);
//       } catch (error) {
//         console.error("Error fetching devices:", error);
//         setDevices([]);
//       }

//       setLoading(false);
//     };

//     fetchDevices();
//   }, [selectedSite, token, selectedCustomer]);

//   const handleEditClick = (device) => {
//     setDeviceToEdit(device);
//     setEditOpen(true);
//   };

//   const handleSaveEdit = (updatedDevice) => {
//     // Map through devices and replace the one with the matching ID
//     setDevices(
//       devices.map((d) => (d.id === updatedDevice.id ? updatedDevice : d)),
//     );
//     setEditOpen(false);
//   };

//   const handleDeleteClick = (device) => {
//     setDeviceToDelete(device);
//     setDeleteOpen(true);
//     setDeleteMessage("");
//     setDeleteError(false);
//   };

//   const handleConfirmDelete = async () => {
//     if (!deviceToDelete) return;

//     try {
//       // const response = await axios({
//       //   url: `${API_URL}/api/delete_device/${deviceToDelete.device_id}/`,
//       //   method: "DELETE",
//       //   headers: {
//       //     Authorization: `Bearer ${token}`,
//       //     Accept: "application/json",
//       //     "Content-Type": "application/json",
//       //   },
//       //   data: {},
//       // });
//       const response = await apiService({
//         url: `/api/delete_device/${deviceToDelete.device_id}/`,
//         method: "DELETE",
//         data: {}, // ✅ keep
//       });

//       // ✅ Success
//       const msg = response.data.message || "Device deleted successfully!";
//       setDeleteMessage(msg);
//       setDeleteError(false);

//       // Optional toast
//       // toast.success(msg);

//       setTimeout(() => {
//         setDevices(devices.filter((d) => d.id !== deviceToDelete.id));
//         setDeleteOpen(false);
//         setDeleteMessage("");
//       }, 1500);
//     } catch (error) {
//       console.error("Error deleting device:", error);

//       const backendMessage =
//         error.response?.data?.error ||
//         error.response?.data?.message ||
//         "Failed to delete device.";

//       setDeleteMessage(backendMessage);
//       setDeleteError(true);

//       // toast.error(backendMessage);
//     }
//   };
//   const handleCancelDelete = () => {
//     setDeleteOpen(false);
//     setDeleteMessage("");
//     setDeleteError(false);
//   };

//   return (
//     <Box className="view-devices-container">


//       <FormControl className="site-select-container" fullWidth>
//   <InputLabel>Select Customer</InputLabel>
//   <Select
//     value={selectedCustomer}
//     label="Select Customer"
//     onChange={(e) => {
//       setSelectedCustomer(e.target.value);
//       setSelectedSite("all");
//       setDevices([]);
//       setSites([]);
//     }}
//   >
//     {customers.length > 0 ? (
//       customers.map((customer) => (
//         <MenuItem
//           key={customer.tb_customer_id}
//           value={customer.tb_customer_id}
//         >
//           {customer.customer_name}
//         </MenuItem>
//       ))
//     ) : (
//       <MenuItem value="" disabled>
//         No Customers Found
//       </MenuItem>
//     )}
//   </Select>
// </FormControl>
//       <FormControl className="site-select-container" fullWidth sx={{ mb: 2 }}>
//         <InputLabel>Select Site</InputLabel>
//         <Select
//           value={selectedSite}
//           label="Select Site"
//           onChange={(e) => setSelectedSite(e.target.value)}
//         >
//           <MenuItem value="all">All</MenuItem>
//           {sites.map((site) => (
//             <MenuItem key={site.site_id} value={site.asset_id}>
//               {site.name}
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>
//       <TableContainer component={Paper} className="device-table">
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Sr No</TableCell>
//               <TableCell>Device Name</TableCell>

//               <TableCell>Latitude</TableCell>
//               <TableCell>Longitude</TableCell>
//               <TableCell>Status</TableCell>
//               <TableCell align="center">Actions</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//              {loading ? (
//     <TableRow>
//       <TableCell colSpan={6} align="center">
//         <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//           <CircularProgress />
//         </Box>
//       </TableCell>
//     </TableRow>
//   ) : devices.length === 0 ? (
//     <TableRow>
//       <TableCell colSpan={6} align="center">
//         No devices found.
//       </TableCell>
//     </TableRow>
//   ) : (
//             devices
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((device, index) => (
//                 <TableRow key={device.id}>
//                   <TableCell>{page * rowsPerPage + index + 1}</TableCell>

//                     <TableCell>
//                       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                         {device.device_name}
//                       </Box>
//                     </TableCell>

//                     {/* <TableCell>{device.device_id}</TableCell> */}

//                     <TableCell>{device.latitude}</TableCell>
//                     <TableCell>{device.longitude}</TableCell>

//                     <TableCell>
//                       <span
//                         style={{
//                           color: device.is_enabled ? "green" : "red",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {device.is_enabled ? "Active" : "Inactive"}
//                       </span>
//                     </TableCell>
//                     <TableCell align="center">
//                       <IconButton
//                         color="primary"
//                         onClick={() => handleEditClick(device)}
//                       >
//                         <EditIcon />
//                       </IconButton>

//                     <IconButton
//                       color="error"
//                       onClick={() => handleDeleteClick(device)}
//                     >
//                       <DeleteIcon />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               )))}
//           </TableBody>
//         </Table>

//         {/* Add this block after </Table> */}
//         <div className="pagination-bar">
//           <div className="rows-select">
//             Rows per page:
//             <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
//               <option value={5}>5</option>
//               <option value={10}>10</option>
//               <option value={25}>25</option>
//             </select>
//           </div>
//           <div className="page-info">
//             {devices.length > 0 ? page * rowsPerPage + 1 : 0}-
//             {Math.min((page + 1) * rowsPerPage, devices.length)} of{" "}
//             {devices.length}
//           </div>
//           <div className="page-arrows">
//             <button disabled={page === 0} onClick={() => setPage(page - 1)}>
//               ‹
//             </button>
//             <button
//               disabled={(page + 1) * rowsPerPage >= devices.length}
//               onClick={() => setPage(page + 1)}
//             >
//               ›
//             </button>
//           </div>
//         </div>
//       </TableContainer>

//       <EditDevice
//         open={editOpen}
//         onClose={() => setEditOpen(false)}
//         device={deviceToEdit}
//         onSave={handleSaveEdit}
//       />

//       {/* Delete Dialog */}
//       <Dialog open={deleteOpen} onClose={handleCancelDelete}>
//         <DialogTitle>Delete Device</DialogTitle>

//         <DialogContent>
//           <DialogContentText>
//             {!deleteMessage && "Are you sure to delete this device?"}
//           </DialogContentText>

//           {/* ✅ Backend Message */}
//           {deleteMessage && (
//             <Box
//               sx={{
//                 mt: 2,
//                 p: 2,
//                 borderRadius: 2,
//                 backgroundColor: deleteError ? "#fdecea" : "#e8f5e9",
//                 color: deleteError ? "#d32f2f" : "#2e7d32",
//                 fontWeight: 500,
//               }}
//             >
//               {deleteMessage}
//             </Box>
//           )}
//         </DialogContent>

//         <DialogActions>
//           {/* ❌ Error → Only OK */}
//           {deleteError && deleteMessage ? (
//             <Button
//               onClick={handleCancelDelete}
//               variant="contained"
//               color="primary"
//             >
//               OK
//             </Button>
//           ) : deleteMessage && !deleteError ? (
//             /* ✅ Success → Done */
//             <Button
//               onClick={handleCancelDelete}
//               variant="contained"
//               color="success"
//             >
//               Done
//             </Button>
//           ) : (
//             /* 🟢 Default → Cancel + Delete */
//             <>
//               <Button onClick={handleCancelDelete} variant="outlined">
//                 Cancel
//               </Button>

//               <Button
//                 onClick={handleConfirmDelete}
//                 variant="contained"
//                 color="error"
//               >
//                 Delete
//               </Button>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ViewDevices;



















import { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { CircularProgress } from "@mui/material";

import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DevicesIcon from "@mui/icons-material/Devices";
import EditDevice from "./EditDevice";
import "./ViewDevice.css";
import apiService from "../../utils/apiservice";



const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const ViewDevices = () => {
  const [devices, setDevices] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deviceToDelete, setDeviceToDelete] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [deviceToEdit, setDeviceToEdit] = useState(null);
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("all"); // default to All
  const token = localStorage.getItem("accessToken");
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("all");
  const [deleteMessage, setDeleteMessage] = useState("");
  const [deleteError, setDeleteError] = useState(false);
  const [loading, setLoading] = useState(false);

  // Add these inside your ViewSites component
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // Add these handlers below your state definitions
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await apiService.get(
          `${API_URL}/api/get_customers/`,
          { data: {} }
        );

        const customerData = response.data || [];
        setCustomers(customerData);

        // if (customerData.length > 0) {
        //   setSelectedCustomer(customerData[0].tb_customer_id);
        // }
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    fetchCustomers();
  }, []);

  // useEffect(() => {
  //   const fetchSites = async () => {
  //     try {
  //       const response = await apiService({
  //         url: `/api/get_customer_sites/${selectedCustomer}/`,
  //         method: "GET",
  //         data: {}, // ✅ keep as it is
  //       });

  //       const siteData = response.data.data;
  //       // setSites(siteData);
  //       // if (siteData.length > 0) {
  //       //   setSelectedSite(siteData[0].asset_id);
  //       // }

  //       setSites(siteData);
  //       // Only set default to first site if selectedSite is empty
  //       if (!selectedSite || selectedSite === "all") {
  //         setSelectedSite("all"); // Keep default as "all"
  //       }
  //     } catch (error) {
  //       console.error("Error fetching sites:", error);
  //     }
  //   };

  //   if (selectedCustomer) fetchSites();
  // }, [selectedCustomer, token]);


  useEffect(() => {
    const fetchSites = async () => {
      try {
        let siteData = [];

        if (selectedCustomer === "all") {
          // combine all customer sites
          customers.forEach((customer) => {
            if (customer.assigned_sites) {
              siteData.push(
                ...customer.assigned_sites.map((site) => ({
                  ...site,
                  site_id: site.asset_id,
                }))
              );
            }
          });
        } else {
          const response = await apiService({
            url: `/api/get_customer_sites/${selectedCustomer}/`,
            method: "GET",
            data: {},
          });

          siteData = response.data.data || [];
        }

        setSites(siteData);
        setSelectedSite("all");
      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    fetchSites();
  }, [selectedCustomer, customers]);



  useEffect(() => {
    const fetchDevices = async () => {
      setLoading(true);

      try {
        let deviceList = [];

        // ✅ CASE 1: All customers + All sites
        if (selectedCustomer === "all" && selectedSite === "all") {
          const response = await axios.get(
            `${API_URL}/api/get_all_devices/`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const allDevices = response.data.data || [];

          deviceList = await Promise.all(
            allDevices.map(async (device, index) => {
              let latitude = "-";
              let longitude = "-";
              let is_enabled = false;

              try {
                const attrRes = await axios.get(
                  `${API_URL}/api/device_attributes/${device.id.id}/`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );

                const attrs = attrRes.data.attributes || [];

                latitude =
                  attrs.find((a) => a.key === "latitude")?.value || "-";
                longitude =
                  attrs.find((a) => a.key === "longitude")?.value || "-";
                is_enabled =
                  attrs.find((a) => a.key === "active")?.value || false;
              } catch (err) {
                console.error("Attribute fetch error:", err);
              }

              return {
                id: index + 1,
                device_id: device.id.id,
                device_name: device.name,
                latitude,
                longitude,
                is_enabled,
              };
            })
          );
        }

        // ✅ CASE 2: Selected customer + All sites
        else if (selectedSite === "all" && selectedCustomer !== "all") {
          const response = await axios.get(
            `${API_URL}/api/customer_alldevices/${selectedCustomer}/?page=0&pageSize=1000`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
              data: {}
            }
          );

          // const allDevices = response.data.data.data || [];
          const allDevices =
            response.data?.data?.data ||
            response.data?.data ||
            [];

          deviceList = await Promise.all(
            allDevices.map(async (device, index) => {
              let latitude = "-";
              let longitude = "-";
              let is_enabled = false;

              try {
                const attrRes = await axios.get(
                  `${API_URL}/api/device_attributes/${device.id.id}/`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );

                const attrs = attrRes.data.attributes || [];

                latitude =
                  attrs.find((a) => a.key === "latitude")?.value || "-";
                longitude =
                  attrs.find((a) => a.key === "longitude")?.value || "-";
                is_enabled =
                  attrs.find((a) => a.key === "active")?.value || false;
              } catch (err) { }

              return {
                id: index + 1,
                device_id: device.id.id,
                device_name: device.name,
                latitude,
                longitude,
                is_enabled,
              };
            })
          );
        }

        // ✅ CASE 3: Specific site
        else {
          const response = await axios.get(
            `${API_URL}/api/site_devices/${selectedSite}/`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const siteDevices = response.data.devices || [];

          deviceList = await Promise.all(
            siteDevices.map(async (device, index) => {
              let latitude = "-";
              let longitude = "-";
              let is_enabled = false;

              try {
                const attrRes = await axios.get(
                  `${API_URL}/api/device_attributes/${device.device_id}/`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );

                const attrs = attrRes.data.attributes || [];

                latitude =
                  attrs.find((a) => a.key === "latitude")?.value || "-";
                longitude =
                  attrs.find((a) => a.key === "longitude")?.value || "-";
                is_enabled =
                  attrs.find((a) => a.key === "active")?.value || false;
              } catch (err) { }

              return {
                id: index + 1,
                device_id: device.device_id,
                device_name: device.device_name,
                latitude,
                longitude,
                is_enabled,
              };
            })
          );
        }

        setDevices(deviceList);
      } catch (error) {
        console.error("Error fetching devices:", error);
        setDevices([]);
      }

      setLoading(false);
    };

    fetchDevices();
  }, [selectedCustomer, selectedSite, token]);

  //   useEffect(() => {
  //     const fetchDevices = async () => {
  //      if (!selectedCustomer && selectedCustomer !== "all") return;
  //       setLoading(true); 

  //       try {
  //         let deviceList = [];

  //         if (selectedSite === "all" && selectedCustomer !== "all") {
  //            let allDevices = [];
  //           // 1️⃣ Fetch all devices for customer
  //           const response = await axios.get(
  //             `${API_URL}/api/customer_alldevices/${selectedCustomer}/?page=0&pageSize=1000`,
  //             {
  //               headers: {
  //                 Authorization: `Bearer ${token}`,
  //                 Accept: "application/json",
  //                 "Content-Type": "application/json",
  //               },
  //               data: {},
  //             }
  //           );

  //           allDevices.push(...(response.data.data.data || []));

  //           // Fetch attributes for each device
  //           deviceList = await Promise.all(
  //             allDevices.map(async (device, index) => {
  //               let latitude = "-";
  //               let longitude = "-";
  //               let is_enabled = false;

  //               try {
  //                 const attrRes = await axios.get(
  //                   `${API_URL}/api/device_attributes/${device.id.id}/`,
  //                   {
  //                     headers: { Authorization: `Bearer ${token}` },
  //                   }
  //                 );

  //                 const attrsArray = attrRes.data.attributes || [];

  //                 const latitudeAttr = attrsArray.find(attr => attr.key === "latitude");
  //                 const longitudeAttr = attrsArray.find(attr => attr.key === "longitude");
  //                 const activeAttr = attrsArray.find(attr => attr.key === "active");

  //                 latitude = latitudeAttr ? latitudeAttr.value : "-";
  //                 longitude = longitudeAttr ? longitudeAttr.value : "-";
  //                 is_enabled = activeAttr ? activeAttr.value : false;
  //               } catch (err) {
  //                 console.error(`Error fetching attributes for ${device.id.id}`, err);
  //               }

  //               return {
  //                 id: index + 1,
  //                 device_id: device.id.id,
  //                 device_name: device.name,
  //                 latitude,
  //                 longitude,
  //                 is_enabled,
  //               };
  //             })
  //           );
  //         } else {
  //           // 2️⃣ Fetch devices for selected site
  //           const response = await axios.get(
  //             `${API_URL}/api/site_devices/${selectedSite}/`,
  //             {
  //               headers: {
  //                 Authorization: `Bearer ${token}`,
  //                 Accept: "application/json",
  //                 "Content-Type": "application/json",
  //               },
  //               data: {},
  //             }
  //           );

  //           const siteDevices = response.data.devices || [];

  //           // Fetch attributes for each device
  //           deviceList = await Promise.all(
  //   siteDevices.map(async (device, index) => {
  //     let latitude = "-";
  //     let longitude = "-";
  //     let is_enabled = false;

  //     try {
  //       const attrRes = await axios.get(
  //         `${API_URL}/api/device_attributes/${device.device_id}/`,
  //         {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }
  //       );

  //       const attrsArray = attrRes.data.attributes || [];

  //       const latitudeAttr = attrsArray.find(attr => attr.key === "latitude");
  //       const longitudeAttr = attrsArray.find(attr => attr.key === "longitude");
  //       const activeAttr = attrsArray.find(attr => attr.key === "active");

  //       latitude = latitudeAttr ? latitudeAttr.value : "-";
  //       longitude = longitudeAttr ? longitudeAttr.value : "-";
  //       is_enabled = activeAttr ? activeAttr.value : false;
  //     } catch (err) {
  //       console.error(
  //         `Error fetching attributes for device ${device.device_id}`,
  //         err
  //       );
  //     }

  //     return {
  //       id: index + 1,
  //       device_id: device.device_id,
  //       device_name: device.device_name,
  //       latitude,
  //       longitude,
  //       is_enabled,
  //     };
  //   })
  // );
  //         }

  //         setDevices(deviceList);
  //       } catch (error) {
  //         console.error("Error fetching devices:", error);
  //         setDevices([]);
  //       }

  //       setLoading(false);
  //     };

  //     fetchDevices();
  //   }, [selectedSite, token, selectedCustomer]);

  const handleEditClick = (device) => {
    setDeviceToEdit(device);
    setEditOpen(true);
  };

  const handleSaveEdit = (updatedDevice) => {
    // Map through devices and replace the one with the matching ID
    setDevices(
      devices.map((d) => (d.id === updatedDevice.id ? updatedDevice : d)),
    );
    setEditOpen(false);
  };

  const handleDeleteClick = (device) => {
    setDeviceToDelete(device);
    setDeleteOpen(true);
    setDeleteMessage("");
    setDeleteError(false);
  };

  const handleConfirmDelete = async () => {
    if (!deviceToDelete) return;

    try {
      // const response = await axios({
      //   url: `${API_URL}/api/delete_device/${deviceToDelete.device_id}/`,
      //   method: "DELETE",
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //     Accept: "application/json",
      //     "Content-Type": "application/json",
      //   },
      //   data: {},
      // });
      const response = await apiService({
        url: `/api/delete_device/${deviceToDelete.device_id}/`,
        method: "DELETE",
        data: {}, // ✅ keep
      });

      // ✅ Success
      const msg = response.data.message || "Device deleted successfully!";
      setDeleteMessage(msg);
      setDeleteError(false);

      // Optional toast
      // toast.success(msg);

      setTimeout(() => {
        setDevices(devices.filter((d) => d.id !== deviceToDelete.id));
        setDeleteOpen(false);
        setDeleteMessage("");
      }, 1500);
    } catch (error) {
      console.error("Error deleting device:", error);

      const backendMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to delete device.";

      setDeleteMessage(backendMessage);
      setDeleteError(true);

      // toast.error(backendMessage);
    }
  };
  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setDeleteMessage("");
    setDeleteError(false);
  };

  return (
    <Box className="view-devices-container">

      <Box
        sx={{
          display: "flex",
          gap: 5,
          mb: 2,
        }}
      >
        <FormControl className="site-select-container" sx={{ width: 300 }}>
          <InputLabel>Select Customer</InputLabel>
          <Select
            value={selectedCustomer}
            label="Select Customer"
            onChange={(e) => {
              setSelectedCustomer(e.target.value);
              setSelectedSite("all");
              setDevices([]);
              setSites([]);
            }}
          >
            <MenuItem value="all">All</MenuItem>
            {customers.length > 0 ? (
              customers.map((customer) => (
                <MenuItem
                  key={customer.tb_customer_id}
                  value={customer.tb_customer_id}
                >
                  {customer.customer_name}
                </MenuItem>
              ))
            ) : (
              <MenuItem value="" disabled>
                No Customers Found
              </MenuItem>
            )}
          </Select>
        </FormControl>
        <FormControl className="site-select-container" sx={{ width: 300 }}>
          <InputLabel>Select Site</InputLabel>
          <Select
            value={selectedSite}
            label="Select Site"
            onChange={(e) => setSelectedSite(e.target.value)}
          >
            <MenuItem value="all">All</MenuItem>
            {sites.map((site) => (
              // <MenuItem key={site.site_id} value={site.asset_id}>
              <MenuItem key={site.asset_id} value={site.asset_id}>
                {site.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <TableContainer component={Paper} className="device-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Device Name</TableCell>

              <TableCell>Latitude</TableCell>
              <TableCell>Longitude</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                    <CircularProgress />
                  </Box>
                </TableCell>
              </TableRow>
            ) : devices.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No devices found.
                </TableCell>
              </TableRow>
            ) : (
              devices
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((device, index) => (
                  // <TableRow key={device.id}>
                  <TableRow key={device.device_id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>

                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {device.device_name}
                      </Box>
                    </TableCell>

                    {/* <TableCell>{device.device_id}</TableCell> */}

                    <TableCell>{device.latitude}</TableCell>
                    <TableCell>{device.longitude}</TableCell>

                    <TableCell>
                      <span
                        style={{
                          color: device.is_enabled ? "green" : "red",
                          fontWeight: "bold",
                        }}
                      >
                        {device.is_enabled ? "Active" : "Inactive"}
                      </span>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        color="primary"
                        onClick={() => handleEditClick(device)}
                      >
                        <EditIcon />
                      </IconButton>

                      <IconButton
                        color="error"
                        onClick={() => handleDeleteClick(device)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                )))}
          </TableBody>
        </Table>


      </TableContainer>
      {/* Add this block after </Table> */}
      <div className="pagination-bar">
        <div className="rows-select">
          Rows per page:
          <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
          </select>
        </div>
        <div className="page-info">
          {devices.length > 0 ? page * rowsPerPage + 1 : 0}-
          {Math.min((page + 1) * rowsPerPage, devices.length)} of{" "}
          {devices.length}
        </div>
        <div className="page-arrows">
          <button disabled={page === 0} onClick={() => setPage(page - 1)}>
            ‹
          </button>
          <button
            disabled={(page + 1) * rowsPerPage >= devices.length}
            onClick={() => setPage(page + 1)}
          >
            ›
          </button>
        </div>
      </div>

      <EditDevice
        open={editOpen}
        onClose={() => setEditOpen(false)}
        device={deviceToEdit}
        onSave={handleSaveEdit}
      />

      {/* Delete Dialog */}
      <Dialog open={deleteOpen} onClose={handleCancelDelete}>
        <DialogTitle>Delete Device</DialogTitle>

        <DialogContent>
          <DialogContentText>
            {!deleteMessage && "Are you sure to delete this device?"}
          </DialogContentText>

          {/* ✅ Backend Message */}
          {deleteMessage && (
            <Box
              sx={{
                mt: 2,
                p: 2,
                borderRadius: 2,
                backgroundColor: deleteError ? "#fdecea" : "#e8f5e9",
                color: deleteError ? "#d32f2f" : "#2e7d32",
                fontWeight: 500,
              }}
            >
              {deleteMessage}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          {/* ❌ Error → Only OK */}
          {deleteError && deleteMessage ? (
            <Button
              onClick={handleCancelDelete}
              variant="contained"
              color="primary"
            >
              OK
            </Button>
          ) : deleteMessage && !deleteError ? (
            /* ✅ Success → Done */
            <Button
              onClick={handleCancelDelete}
              variant="contained"
              color="success"
            >
              Done
            </Button>
          ) : (
            /* 🟢 Default → Cancel + Delete */
            <>
              <Button onClick={handleCancelDelete} variant="outlined">
                Cancel
              </Button>

              <Button
                onClick={handleConfirmDelete}
                variant="contained"
                color="error"
              >
                Delete
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ViewDevices;

